var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Liên kết tài khoản và tạo VA",
            "before-close": _vm.handleClose,
            visible: _vm.isOTPAuthenticationKienLongBankDialog,
            "show-close": true,
            "close-on-click-modal": false,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isOTPAuthenticationKienLongBankDialog = $event
            },
            open: _vm.handleOpen,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                "label-width": "140px",
                model: _vm.formData,
                "label-position": "left",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Tên gợi nhớ", prop: "label" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      placeholder: "Nhập tên gợi nhớ",
                      maxlength: "100",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.formData.label,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "label", $$v)
                      },
                      expression: "formData.label",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    type: "primary",
                    size: "medium",
                    loading: _vm.loading.submit,
                  },
                  on: { click: _vm.submitForm },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-check" }),
                  _c("span", [_vm._v("Liên kết")]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }